import { createSlice } from '@reduxjs/toolkit';
import { addFan, deleteFan, fetchFans } from './operations';
const initialState = {
  fanList: [],
};

export const sliceFans = createSlice({
  name: 'Fans',
  initialState,

  extraReducers: builder => {
    builder
      .addCase(fetchFans.fulfilled, (state, { payload: userData }) => {
        state.fanList = userData;
      })
      .addCase(deleteFan.fulfilled, (state, { payload: userData }) => {
        state.fanList = state.fanList.filter(el => el._id !== userData);
      })
      .addCase(addFan.fulfilled, (state, { payload: userData }) => {
        state.fanList.push(userData);
      });
  },
});

export default sliceFans.reducer;
